module.exports = __webpack_public_path__ + "static/media/russian.f3f79679.svg";